import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import {
	ButtonComponent,
	HeadlineComponent,
	TextAreaComponent,
	TextComponent,
} from '@zeiss/beyond-online-angular';
import { finalize, first, tap } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ConfigurationStore } from 'src/app/state-management/stores/configuration.store';
import { environment } from 'src/environments/environment';
import { IconComponent, PopUpConfig, PopUpRef, ToastService, ToastType } from 'vis-ods-angular';
import { ServerErrorDisplayDataInterface } from '../../../../types/interfaces/server-error-display-data.interface';

@Component({
	selector: 'app-report-issue-popup',
	templateUrl: './report-issue-popup.component.html',
	imports: [
		TranslocoModule,
		ReactiveFormsModule,
		IconComponent,
		TextAreaComponent,
		HeadlineComponent,
		TextComponent,
		ButtonComponent,
	],
})
export class ReportIssuePopupComponent {
	private configurationStore = inject(ConfigurationStore);

	errorForm = this.fb.group({
		description: [''],
	});
	isSubmitting = false;

	settings = this.configurationStore.settings;

	constructor(
		private readonly fb: FormBuilder,
		public popUpConfig: PopUpConfig<ServerErrorDisplayDataInterface>,
		private readonly popUpRef: PopUpRef,
		private readonly apiService: ApiService,
		private readonly toastService: ToastService,
		private readonly translocoService: TranslocoService,
	) {}

	get myZeissUrl() {
		return environment.myZeissUrl;
	}

	submitTicket() {
		this.isSubmitting = true;
		this.popUpRef.close();
		let requestLoadingToast = this.toastService.addToast({
			headline: this.translocoService.translate(
				'generalComponents.reportIssuePopupBackgroundRequest.headlines.title',
			),
			variant: ToastType.info,
			description: this.translocoService.translate(
				'generalComponents.reportIssuePopupBackgroundRequest.texts.message',
			),
			disableAutomaticDelete: true,
		});

		this.apiService
			.reportError({
				userComment: this.errorForm.value.description || '',
				errorId: this.popUpConfig.data?.errorId || '',
			})
			.pipe(
				tap({
					next: (val) => val,
					error: () => requestLoadingToast.close(),
				}),
				finalize(() => {
					this.isSubmitting = false;
				}),
			)
			.subscribe(() => {
				requestLoadingToast.close();
				const errorReportedToast = this.toastService.addToast({
					headline: this.translocoService.translate(
						'generalComponents.reportIssuePopupSuccess.headlines.title',
					),
					variant: ToastType.success,
					description: this.translocoService.translate(
						'generalComponents.reportIssuePopupSuccess.texts.message',
					),
					isButtonVisible: true,
					buttonLabel: this.translocoService.translate(
						'generalComponents.reportIssuePopupSuccess.buttons.myInquiries',
					),
				});

				const subscription = errorReportedToast.buttonClicked.subscribe(() => {
					window.open(this.settings()?.links_myzeiss_inquiry, '_blank');
				});
				errorReportedToast.afterClosed.pipe(first()).subscribe(() => {
					subscription.unsubscribe();
				});
			});
	}
}
